import AppConfiguration from 'src/types/appConfiguration';

export default {
  siteTitle: 'SITE_TITLE_BILLON_UNIFIED_BLOCKCHAIN',
  documentPrivate: true,
  documentPublic: true,
  documentVerification: false,
  documentRemoteSigning: true,
  userLogin: true,
  userRegistration: true,
  userResetPassword: false,
  mockEndpoints: false,
  diploma: false,
  documentPrivateCategoryFilter: false,
  documentPrivateCategories: true,
  envPrefix: 'DEV'
} as AppConfiguration;
